import { useApi } from '@/api';
import { Carousel } from '@/components';
import {
  Box,
  Card,
  CurrencyValue,
  Flex,
  FlexProps,
  NetworkIcon,
  PercentageValue,
  TableSkeleton
} from '@blockanalitica/ui';
import _ from 'lodash';
import { useParams } from 'react-router';
import styled, { css } from 'styled-components';

type VaultsData = {
  symbol: string;
  circulating_supply: string;
  network: string;
  rate: string;
  underlying_address: string;
  underlying_symbol: string;
  address: string;
  name: string | null;
};

const KpiTitle = styled(Flex)<FlexProps>`
  ${(props) => css`
    color: ${props.theme.colors.muted};
    font-size: ${props.theme.sizes['-1']};
  `}
`;

export default function TokenVaults() {
  const { symbol } = useParams();
  const [data, error] = useApi<VaultsData[]>({
    url: `/sparkstar/savings/vaults/${symbol}/tokens/`
  });

  if (error) {
    throw error;
  }
  if (!data) {
    // TODO: wrong skeleton
    return <TableSkeleton rows={10} columns={6} />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <Carousel>
        {data.map((row) => (
          <Card
            key={row.address}
            gap="s"
            justifyContent="space-between"
            flexDirection="column">
            <Flex flexDirection="column" gap="s">
              <Flex gap={['s', 'xs']} alignItems="center">
                <NetworkIcon network={row.network} key={row.network} size="3" />
                {_.capitalize(row.network)}
              </Flex>

              <Flex gap="xs">
                <Flex flexDirection="column" flex="1" gap="3xs">
                  <KpiTitle>Deposits</KpiTitle>

                  <CurrencyValue
                    value={row.circulating_supply}
                    options={{ currency: 'USD' }}
                    fontSize="4"
                    variant="dynamic"
                  />
                </Flex>
                <Box fontSize="-1" marginLeft="auto">
                  <KpiTitle color="muted" fontSize="-1">
                    APY
                  </KpiTitle>

                  <PercentageValue
                    value={row.rate}
                    fontSize="4"
                    variant="dynamic"
                  />
                </Box>
              </Flex>
            </Flex>
          </Card>
        ))}
      </Carousel>
    </Flex>
  );
}
